import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBzShGgAL5RXY00Bh_P4TiH7K4Jjo880MQ",
  authDomain: "clone-377714.firebaseapp.com",
  projectId: "youtube-clone-377714",
  storageBucket: "youtube-clone-377714.appspot.com",
  messagingSenderId: "483067321364",
  appId: "1:483067321364:web:3094dbcbd4fcd0bb681b01",
  measurementId: "G-26DLZ91HQQ"
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export { firebase, db, firebaseConfig };